module.exports = __webpack_public_path__ + "static/media/04_tn.e101d938.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/black/thumbnails/04_tn.jpg
// module id = 218
// module chunks = 0